<template>
    <div class="py-4 px-5">
        <h2 class="mb-4">Edition d'un utilisateur</h2>
        
        <div v-if="error.length" class="alert alert-danger" role="alert">
        {{ error }}
        </div>

        <form method="POST" @submit="sendForm">
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="inputEmail4">Prénom</label>
                    <input v-model="user.givenName" type="text" class="form-control" id="givenName" placeholder="Prénom" required>
                </div>
                <div class="form-group col-md-6">
                    <label for="inputPassword4">Nom</label>
                    <input v-model="user.sn" type="text" class="form-control" id="sn" placeholder="Nom" required>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="inputEmail4">Mail</label>
                    <input v-model="user.mail" type="email" class="form-control" id="mail" placeholder="Mail" required>
                </div>
                <div class="form-group col-md-6">
                    <label for="inputPassword4">Numéro de téléphone</label>
                    <input v-model="user.telephoneNumber" type="text" class="form-control" id="telephoneNumber" placeholder="Numéro de téléphone">
                </div>
            </div>
            <div class="form-group">
                <label for="exampleInputPassword1">Description</label>
                <textarea class="form-control" v-model="user.description" id="description" rows="3"></textarea>
            </div>
            
            <button type="submit" class="btn btn-primary">Enregistrer</button>
        </form>
    </div>
</template>
<script>
import conf from '../../../../config/api.js'

export default {
    data() {
            return {
                conf: conf,
                 uid: '',
                 user: {},
                 error: "",
            }
        },
        beforeMount() { // Récupération des utilisateurs
            this.uid = this.$route.params.uid
            //console.log(this.$route.params.uid)
            this.axios.get(`${conf.server}/api/ldap/user/` + this.uid) // On fait une requête axios en GET vers l'API afin de récupérer les informations de l'utilisateur
            .then((result) => {
                this.user = result.data.data[0] // On stocke les informations de l'utilisateur dans la variable user
                console.log(this.user)
            }).catch((err) => {
                console.log(err)
            });
        },
        methods: {
            sendForm: function(e) { // Fonction qui envoie les données du formulaire
                e.preventDefault(); // On empêche le comportement par défaut du navigateur

                console.log(this.user.givenName)

                this.axios.post(`${conf.server}/api/ldap/user/` + this.uid + `/edit`, { // On fait une requête axios en POST vers l'API afin de modifier les informations de l'utilisateur
                    givenName: this.user.givenName,
                    sn: this.user.sn,
                    mail: this.user.mail,
                    telephoneNumber: this.user.telephoneNumber,
                    description: this.user.description,
                })
                .then((response) => { // Si la requête s'est bien passée
                    this.error = "" // On vide l'erreur
                    console.log(response)
                    window.location.href = `${conf.server}/user/` + this.uid + '/details' // On redirige l'utilisateur vers la page de détails de l'utilisateur
                })
                .catch((err) => {
                    console.log(err)
                    this.error = err.response.data.message // On affiche l'erreur
                })
            }
        }
}
</script>